import SavedActivities from "@/pages/comunications/saved-activities"
import WeeklyObjetiveAchieved from "@/pages/comunications/objective-achieved"
import type { RouteObject } from "react-router-dom"

const route: RouteObject = {
  path: "comunications/:id",
  children: [
    {
      index: true,
      element: <WeeklyObjetiveAchieved />,
    },
    {
      path: "saved-activities",
      element: <SavedActivities />,
    },
  ],
}

export default route
